import React, {
  InputHTMLAttributes,
  ChangeEvent,
  FocusEvent,
  ReactNode,
} from "react";
import { Icon, InputContainer, InputField } from "./style";
import { FieldInputProps } from "formik";

interface InputWithIconProps extends InputHTMLAttributes<HTMLInputElement> {
  icon: ReactNode;
  iconSize?: string;
  type?: string;
  field?: FieldInputProps<any> & {
    onBlur?: (
      e: FocusEvent<any, Element> | React.FocusEvent<HTMLInputElement>
    ) => void;
  };
  rightIcon?: React.ReactNode;
}

const InputWithIcon: React.FC<InputWithIconProps> = ({
  icon,
  iconSize,
  field,
  type,
  rightIcon,
  ...inputProps
}) => {
  const { name, onBlur, onChange, value, ...rest } = field || {};

  return (
    <InputContainer>
      {/* Ícone à esquerda */}
      {icon && <Icon iconSize={iconSize}>{icon}</Icon>}

      {/* Input */}
      <InputField
        name={name}
        onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
          onBlur?.(e);
        }}
        onChange={onChange}
        value={value}
        {...inputProps}
        {...rest}
        type={type || "text"}
        style={{
          paddingRight: rightIcon ? "40px" : undefined, // espaço pro ícone à direita
        }}
      />

      {/* Ícone à direita */}
      {rightIcon && (
        <div
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#50700F",
          }}
        >
          {rightIcon}
        </div>
      )}
    </InputContainer>
  );
};

export default InputWithIcon;
